export class Page {
    id: string;
    name: string;
    siteId: string;
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/page.ts